import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { translationES } from '../locales';

const i18nClient = i18n
	.use(LanguageDetector)
	.init({
		load: 'all',
		whitelist: ['es', 'es-ES'],
		nonExplicitWhitelist: false,
		lngs: ['es-ES'],
		fallbackLng: 'es-ES',
		interpolation: {
			escapeValue: false, // not needed for react!!
		},
		react: {
			wait: true, // set to true if you like to wait for loaded in every translated hoc
			nsMode: 'default', // set it to fallback to let passed namespaces to translated hoc act as fallbacks
		},
		defaultNS: 'locale.constant',
		resources: {
			es: {
				'locale.constant': translationES,
			},
			'es-ES': {
				'locale.constant': translationES,
			},
		},
	});

export default i18nClient;
